import { Plugin } from '@ckeditor/ckeditor5-core';
import { MediaEmbed } from '@ckeditor/ckeditor5-media-embed';
import ResizeMediaCommand from './resizemediacommand';

export default class MediaResizeEditing extends Plugin {
    /**
     * @inheritDoc
     */
    static get requires() {
        return [MediaEmbed];
    }
    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'MediaResizeEditing';
    }

    /**
     * @inheritDoc
     */
    init() {
        const editor = this.editor;
        const resizeMediaCommand = new ResizeMediaCommand(editor);
        this.editor.model.schema.extend('media', { allowAttributes: 'width' });
        editor.conversion.for('downcast').add(dispatcher => dispatcher.on(`attribute:width:media`, (evt, data, conversionApi) => {
            if (!conversionApi.consumable.consume(data.item, evt.name)) {
                return;
            }
            const viewWriter = conversionApi.writer;
            const figure = conversionApi.mapper.toViewElement(data.item);
            if (data.attributeNewValue !== null) {
                viewWriter.setStyle('width', data.attributeNewValue, figure);
                viewWriter.addClass('media_resized', figure);
            }
            else {
                viewWriter.removeStyle('width', figure);
                viewWriter.removeClass('media_resized', figure);
            }
        }));
        editor.conversion.for('upcast')
            .attributeToAttribute({
            view: {
                name: 'figure',
                styles: {
                    width: /.+/
                }
            },
            model: {
                key: 'width',
                value: (viewElement) => viewElement.getStyle('width')
            }
        });

        editor.commands.add('resizeMedia', resizeMediaCommand);
        editor.commands.add('mediaResize', resizeMediaCommand);
    }
}
//# sourceMappingURL=mediaresizeediting.js.map